import { api } from "api/api";
import { AxiosError } from "axios";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import Cte from "model/transportes/cte/Cte";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

export default class CteService implements BaseServiceCadastros<Cte> {
    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/cte/pesquisar`;

            if(filters){
                url += getFilters(filters);
            }

            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<Cte>((resolve, reject): void => {
            api
                .get(`/cte/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(cte: Cte) {
        return new Promise<Cte>((resolve, reject): void => {

        });
    }

    editar(cte: Cte) {
        return new Promise<Cte>((resolve, reject): void => {

        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/cte/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    importarXml(xmls: string[]) {
        return new Promise<void>((resolve, reject): void => {
            api
                .post('/cte/importarXml', xmls)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getDacte(id: number) {

        return new Promise<string>((resolve, reject): void => {
            api
                .get(`/cte/dacte/${id}`, { responseType: 'arraybuffer' })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

}